import { FlashcardReview, FlashcardReviewProps } from '../../domain/entities/FlashcardReview';
import { FlashcardReviewDTO } from '../dto/FlashcardReviewDTO';

export class FlashcardReviewMapper {
  static toDTO(review: FlashcardReview): FlashcardReviewDTO {
    return {
      id: review.id,
      flashcardId: review.flashcardId,
      studentId: review.studentId,
      easinessFactor: review.easinessFactor,
      intervalDays: review.intervalDays,
      repetitions: review.repetitions,
      nextReviewDate: review.nextReviewDate.toISOString(),
      lastQuality: review.lastQuality,
      lastReviewedAt: review.lastReviewedAt?.toISOString() ?? null,
      totalReviews: review.totalReviews,
      isDue: review.isDue(),
      isMastered: review.isMastered(),
    };
  }

  static fromDatabaseRow(row: Record<string, unknown>): FlashcardReview {
    const r = row as {
      id: number;
      flashcard_id: number;
      student_id: string;
      easiness_factor: number;
      interval_days: number;
      repetitions: number;
      next_review_date: string;
      last_quality: number | null;
      last_reviewed_at: string | null;
      total_reviews: number;
    };

    const props: FlashcardReviewProps = {
      id: String(r.id),
      flashcardId: String(r.flashcard_id),
      studentId: r.student_id,
      easinessFactor: r.easiness_factor,
      intervalDays: r.interval_days,
      repetitions: r.repetitions,
      nextReviewDate: new Date(r.next_review_date),
      lastQuality: r.last_quality,
      lastReviewedAt: r.last_reviewed_at ? new Date(r.last_reviewed_at) : null,
      totalReviews: r.total_reviews,
    };
    return new FlashcardReview(props);
  }
}
